export const REQUEST_GET_MAGNET_MESSAGE = "REQUEST_GET_MAGNET_MESSAGE";
export const SUCCESS_GET_MAGNET_MESSAGE = "SUCCESS_GET_MAGNET_MESSAGE";